module.exports = __webpack_public_path__ + "static/media/Logo.dcbcb13a.png";